import { Card, Divider, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { ORDER_STATUS } from '../../../utils/enums';
import { onGetDateFormat, onGetDateWithTimezone } from '../../../utils/formatTime';
import TextButton from '../../actions/TextButton';
import Send2ShipmentModal from '../../../modals/Orders/ShipmentModals/Send2ShipmentModal';

const ShippingDetails = ({
    order, onUpdateShip
}) => {

    const [open, setOpen] = useState(false)
    
    const estimated_date = onGetDateFormat(order?.estimated_delivery_date, 'DD MMM YY')
    const date = onGetDateFormat(order?.delivered_at, 'DD MMM YY')
    

    return ( 
        <>
            <Card sx={{px:2, py:2}}>
                <Typography variant='subtitle1'>Información de envío</Typography>
                <Divider sx={{my:1}} />
                <Box>
                    <Grid container>
                        <Grid item xs={12}>
                            <Stack direction='row' spacing={1}>
                                <Typography variant='body2' color='textSecondary'>Fecha estimada de entrega</Typography>
                                <Typography variant='subtitle2'>{estimated_date ?? '-'}</Typography>
                            </Stack>
                            <Stack direction='row' spacing={1}>
                                <Typography variant='body2' color='textSecondary'>Fecha de entrega</Typography>
                                <Typography variant='subtitle2'>{date ?? '-'}</Typography>
                            </Stack>
                            <Stack direction='row' spacing={1}>
                                <Typography variant='body2' color='textSecondary'>Empresa</Typography>
                                <Typography variant='subtitle2'>{order?.shipping_company ?? '-'}</Typography>
                            </Stack>
                            <Stack direction='row' spacing={1}>
                                <Typography variant='body2' color='textSecondary'>No. de seguimiento</Typography>
                                <Typography variant='subtitle2'>{order?.tracking_number ?? '-'}</Typography>
                            </Stack>
                            
                            <Stack direction='row' spacing={1}>
                                <Typography variant='body2' color='textSecondary'>Comentarios</Typography>
                                <Typography variant='subtitle2'>{order?.shipping_details ?? '-'}</Typography>
                            </Stack>
                        </Grid>                
                    </Grid>
                </Box>
                <Stack alignItems='flex-end'>
                    <TextButton size='small' onClick={onUpdateShip}>
                        modificar
                    </TextButton>
                </Stack>
            </Card>
            <Send2ShipmentModal
                order={order}
                open={open}
                onClose={() => setOpen(false)}
            />
        </>
     );
}
 
export default ShippingDetails;